import { createTeamResourceContext } from './createTeamResourceContext'
import useTeamIngressesResources from '../shared/resources/api/v1/admin/docker/useTeamIngressesResources'

const { Provider: IngressesProvider, useHook: useIngresses } = createTeamResourceContext({
  name: 'Ingresses',
  useResources: useTeamIngressesResources,
  responseKey: 'ingresses',
  requestOptions: { limit: 500 },
  lookups: [{ key: 'ingressesById', field: 'id' }],
  groupings: [{ key: 'ingressesByServiceId', field: 'serviceId' }],
})

export { IngressesProvider, useIngresses }
